import React from 'react';
import NextLink from 'next/link';
import { stripPreSlash } from '@/utils/slash-utils';

export function MarkdownLink({
  children,
  url = '',
  href = url,
}: {
  children: React.ReactNode;
  url?: string;
  href: string;
}): React.JSX.Element | null {
  const isExternal = href.startsWith('http');
  const slug = isExternal ? href : `/${stripPreSlash(href)}`;

  if (!slug) {
    return null;
  }

  return (
    <NextLink
      href={slug}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      target={isExternal ? '_blank' : undefined}>
      {children}
    </NextLink>
  );
}
